import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面不存在 - WWW.17C影视平台",
    description: "抱歉，你访问的页面不存在。返回 WWW.17C 首页，继续浏览丰富的影视内容与最新资讯。",
    keywords: "页面不存在,WWW.17C,影视平台",
  });

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[1400px] flex-col items-center justify-center px-4 py-16 text-center md:px-8">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-100 text-4xl text-foreground-400">
        <i className="ri-compass-3-line"></i>
      </span>
      <h1 className="mt-6 font-heading text-3xl font-extrabold text-foreground-950 md:text-4xl">
        404 · 页面走丢了
      </h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面不存在或已被移除。不妨回到首页，看看正在热映的作品和最新的影视资讯。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/news"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-secondary-400 hover:text-secondary-600"
        >
          <i className="ri-newspaper-line"></i>
          浏览资讯
        </Link>
      </div>
    </div>
  );
}